import { createFileRoute } from "@tanstack/react-router";

import { Roles } from "@/features/admin";

export const Route = createFileRoute("/admin/roles")({
  component: Roles,
});
